import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import './Header.css';

function Header() {
  const { isAuthenticated, logout } = useAuth();
  const [eventTitle, setEventTitle] = useState('FantaSea Fishing');
  const [eventLogoUrl, setEventLogoUrl] = useState('/images/FantaSea_Logo.png');

  useEffect(() => {
    const fetchEventInfo = async () => {
      try {
        const response = await api.get('/settings/event-info');
        if (response.data.event_title) {
          setEventTitle(response.data.event_title);
        }
        if (response.data.event_logo_url) {
          setEventLogoUrl(response.data.event_logo_url);
        }
      } catch (error) {
        console.error('Error fetching event info:', error);
      }
    };
    fetchEventInfo();
  }, []);

  return (
    <header className="header">
      <div className="logo">
        <img src={eventLogoUrl} alt={`${eventTitle} Logo`} />
        <h1>{eventTitle}</h1>
      </div>
      <nav>
        <ul>
          {isAuthenticated ? (
            <>
              <li><NavLink to="/setup" className={({ isActive }) => `btn btn-primary${isActive ? ' active' : ''}`}>Setup</NavLink></li>
              <li><NavLink to="/register-angler" className={({ isActive }) => `btn btn-primary${isActive ? ' active' : ''}`}>Register Angler</NavLink></li>
              <li><NavLink to="/weigh-in" className={({ isActive }) => `btn btn-primary${isActive ? ' active' : ''}`}>Weigh-In</NavLink></li>
              <li><NavLink to="/results" className={({ isActive }) => `btn btn-primary${isActive ? ' active' : ''}`}>Results</NavLink></li>
              <li><NavLink to="/prizes" className={({ isActive }) => `btn btn-primary${isActive ? ' active' : ''}`}>Prizes</NavLink></li>
              <li><button onClick={logout} className="btn btn-danger">Logout</button></li>
            </>
          ) : (
            <li><NavLink to="/login" className={({ isActive }) => `btn btn-primary${isActive ? ' active' : ''}`}>Login</NavLink></li>
          )}
        </ul>
      </nav>
    </header>
  );
}

export default Header;